/**
 * Currency helpers for the tenant's active currency (ISO code from `/company/profile`).
 * Semantics mirror `store/src/lib/menu-format.ts` so all apps agree on what "SAR" means.
 */

/** Normalized currency label; defaults to SAR when unset. */
export function currencyLabel(currency?: string | null): string {
	return currency?.trim() || "SAR";
}

/** True when the code/symbol denotes the Saudi Riyal (SAR, ر.س, ر.س., ﷼). */
export function isSaudiRiyal(currency?: string | null): boolean {
	const normalized = currencyLabel(currency).toUpperCase();
	return normalized === "SAR" || normalized === "ر.س" || normalized === "ر.س." || normalized === "﷼";
}

/** CSS class rendering the Saudi Riyal glyph (via ::before); empty for other currencies. */
export function currencyIconClass(currency?: string | null): string {
	return isSaudiRiyal(currency) ? "icon-saudi_riyal" : "";
}
